export interface IUrlInfoType {
  system: string;
  realPath: string;
}

// 系统路径解析
export function parseCommonUrlInfo(str: string = ''): IUrlInfoType {
  const [_null, system, ...arr] = str.trim().split('/');
  const realPath = arr.length > 0 ? arr.join('/') : '';
  return {
    system,
    realPath
  }
}


export const getPathWithoutSearchParams = (str?: string): string => {
  if (!str) return '';
  const idx = str.lastIndexOf('?');
  return idx === -1 ? str : str.substring(0, idx);
};
